<template>
  <v-container class="pt-7">
    <Carousel :banners="banners" rounded />
    <Spacer />
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Carousel from '@/components/Carousel.vue'
import Spacer from '@/components/Spacer.vue'

export default {
  components: { Carousel, Spacer },

  computed: {
    ...mapGetters('page', ['promoBanners']),
    banners() {
      return this.promoBanners
        ? this.promoBanners.map((item) => {
            let redirectBody = {}
            switch (item.redirect_type) {
              case 1:
                redirectBody = { url: item.url }
                break
              case 2:
                redirectBody = { name: this.$constants.ROUTE_NAME.PRODUCT_DETAIL, params: { productId: item.redirect_id } }
                break
              case 3:
                redirectBody = { name: this.$constants.ROUTE_NAME.ARTICLE_DETAIL, params: { articleId: item.redirect_id } }
                break
            }
            return {
              image_desktop: item.image_desktop,
              redirect: redirectBody
            }
          })
        : []
    }
  }
}
</script>
